export const Network = "Binance Smart Chain testnet";
const nativeCurrency = {
  name: "BNB",
  symbol: "BNB",
  decimals: 18,
};
export const NetworkContextName = Network;
// export const ACTIVE_NETWORK = 97;
export const ACTIVE_NETWORK = 56;
